<div id="ui-base-datepicker">
  <div class="input-group">
    <img
      class="icon"
      [src]="'/assets/icons/calendar-' + iconVariant + '.svg'"
      alt="Calendar icon"
      (click)="open()"
    />
    <input
      #dateInput
      type="text"
      [class]="['form-control', inputErrorClass]"
      [value]="value"
      [placeholder]="placeholder"
      maxlength="10"
      ngbDatepicker
      #dp="ngbDatepicker"
      (click)="open()"
      (dateSelect)="onDateSelect($event)"
      (input)="onInput()"
      (blur)="onBlur()"
      [attr.disabled]="disabledAttr"
    />
  </div>
</div>

<div id="datepicker-error">
  <div *ngIf="showError" class="d-flex gap-3 ms-3 mt-3">
    <img
      class="icon"
      src="/assets/icons/exclamation-triangle-solid.svg"
      alt="Warning"
    />
    <span class="error-message">{{ errorMessage }}</span>
  </div>
</div>
